import { useGetConversationSuspenseQuery } from "#features/conversations/api/useGetConversationSuspenseQuery.ts";
import { isGenerating } from "#features/conversations/utils/assistantStatus.ts";

export const useIsAssistantGenerating = (conversationId: string) => {
    const { data: conversation } = useGetConversationSuspenseQuery(conversationId);

    const lastAssistantMessage = [...conversation.messages].reverse().find(m => m.role === "assistant");

    return lastAssistantMessage ? isGenerating(lastAssistantMessage.assistantStatus) : false;
};
